// React
import React, { useEffect } from 'react';

// Hooks
import useComponents from "../../../../Hooks/Display/useComponents";
import { usePropsStoreValue } from "../../../../Hooks/PropStore/usePropsStore";
import { useChangeBooleans } from '../../../../Hooks/Display/useComponentProperties';

// utils
import { getComponentByProperty } from "../../Components/utils";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { itemRender, valueRender } from './DropdownRenderers';
import RuntimeConfigPageHeading from './RuntimeConfigPageHeading';
import ExtraOptionsMenu from './ExtraOptionsMenu';
import { SET_SELECTED_COMPONENT } from '../../../../Context/Display/Components/ComponentsContextEvents';
import useConfirmationDialog from '../../../Shared/ConfirmationWithContext/useConfirmationDialog';
import { useTranslation } from 'react-i18next';

function ComponentToolbar({ onSave, onReset }) {

    const [{ components, selectedComponentIndex }, dispatchComponent] = useComponents();
    const selectedComponent = getComponentByProperty(components, "treeIndex", selectedComponentIndex)

    const accessedFromDesigner = usePropsStoreValue("accessedFromDesigner");

    const [showConfirmationDialog, closeConfirmationDialog] = useConfirmationDialog();

    const [{
        isGeneralPropertiesChanged,
        isAttributeFormBuilderChanged,
        isActionTableChanged,
        isAttributeTableChanged,
        isReferenceTableChanged
    }] = useChangeBooleans();

    const { t } = useTranslation("display/component_toolbar", { useSuspense: false });

    // states
    const publishingComponent = false;
    const inputDisabled = true;
    const savingComponent = false;
    const enableSaveButton = (
        isGeneralPropertiesChanged ||
        isAttributeFormBuilderChanged ||
        isActionTableChanged ||
        isAttributeTableChanged ||
        isReferenceTableChanged
    );

    // functions
    async function handleComponentSwitch(event) {
        // keep this destructing because after the 'await',
        // event.target.value will change to the selected component
        const { value: newSelectedComponent } = event.target;
        let shouldContinue = true;
        if (isGeneralPropertiesChanged || isAttributeFormBuilderChanged || isActionTableChanged || isAttributeTableChanged || isReferenceTableChanged) {
            shouldContinue = await showConfirmationDialog({
                title: "Unsaved Changes",
                content: "You can save the changes made to this component. Then once you update the page, the changes made to all components of this change will be updated.",
                confirmButtonText: "Save",
                cancelButtonText: "Don't Save",
                onConfirm: handleSave
            });
            closeConfirmationDialog();
        }
        if (shouldContinue) {
            dispatchComponent({
                type: SET_SELECTED_COMPONENT,
                payload: newSelectedComponent.treeIndex
            })
        }
    }

    async function handleSave() {
        await onSave();
    }

    return (
        <div className="component-toolbar">
            {
                !accessedFromDesigner &&
                <RuntimeConfigPageHeading handleSave={handleSave} />
            }
            <div className="d-flex align-items-center edit">
                <div>
                    {selectedComponent.componentType === "Stacked Section" ||
                        selectedComponent.componentType === "Split Section" ? (
                        <div className="bigger">
                            {" "}
                            {selectedComponent.componentName}
                        </div>
                    ) : (
                        <DropDownList
                            value={getComponentByProperty(components, "treeIndex", selectedComponentIndex)}
                            textField={"componentName"}
                            onChange={handleComponentSwitch}
                            itemRender={itemRender}
                            valueRender={valueRender}
                            data={components}
                            className="form-control-custom"
                            style={{ width: "150px" }}
                        />
                    )}
                </div>
                <div
                    className="d-flex align-items-center justify-content-end"
                    style={{ height: 40, flexGrow: inputDisabled ? 1 : 0 }}
                >
                    {
                        selectedComponent.hidden &&
                        <span className="text-danger">
                            {t("errors.component_disabled")}
                        </span>
                    }
                    {accessedFromDesigner && (
                        <button
                            title={t("buttons.save")}
                            onClick={handleSave}
                            type="button"
                            disabled={!enableSaveButton}
                            className="mx-2 btn btn-primary"
                        >
                            <i className="mx-1 fas fa-save"></i>
                            {t("buttons.save")}
                        </button>
                    )}
                    <ExtraOptionsMenu
                        disabled={!enableSaveButton}
                        onReset={onReset} />
                </div>
            </div>
        </div>
    )
}

export default ComponentToolbar;